export default "__VITE_ASSET__DfnWc0oa__"